module.exports = __SPARKY_LIBS__.PanWDSReactUIV8;